import { api } from "../../app/api";
import { Options } from "../../common/types/requestOptions";
import { WorkPeriodType } from "../orders/types/workPeriodType";

export interface VariationSpecificSettings {
  periodStartDateIsRequired: boolean;
  isAveragingPeriodInUse: boolean;
  periodType: WorkPeriodType;
  supplements: SupplementsData;
}

export type SupplementInputType = "VALUE" | "TIME_RANGE";

export interface SupplementDefinition {
  type: string;
  unitCode?: string;
  exclusivityGroup?: number;
  inputTypes?: SupplementInputType[];
}

export interface SupplementsData {
  [key: string]: {
    isActive?: boolean;
    mode: string;
    definition?: SupplementDefinition;
  };
}

export interface SupplementDefinitions {
  [key: string]: {
    type: string;
  };
}

export interface GetSupplementDefinitionsRequest {
  tesId: string;
  tesSelections: [string, string][];
  date: string;
}

//tesId=tes_id_marava&date=2023-01-01&tesSelections=%5B%5B%22Ylity%C3%B6raja%22%2C%20%227.5h%22%5D%5D
export const getVariationSpecificSettings = (
  getSupplementDefinitionsRequest: GetSupplementDefinitionsRequest,
  { requestId }: Options,
) => {
  return api.get<VariationSpecificSettings>(
    "/working/qry/variationSpecificSettings",
    {
      requestId,
      queryParams: {
        tesId: getSupplementDefinitionsRequest.tesId,
        date: getSupplementDefinitionsRequest.date,
        tesSelections: JSON.stringify(
          getSupplementDefinitionsRequest.tesSelections,
        ),
      },
      auth: true,
    },
  );
};
